import React, { useState } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { Link, useLocation } from "react-router-dom";
import { useSidebarData } from "../../core/json/siderbar_data";
import HorizontalSidebar from "./horizontalSidebar";
import CollapsedSidebar from "./collapsedSidebar";

const Sidebar = () => {
  const Location = useLocation();
  const [subOpen, setSubopen] = useState("");
  const [subsidebar, setSubsidebar] = useState("");
  
  
  const   sidebarData = useSidebarData();

  const toggleSidebar = (title) => {
    if (title === subOpen) {
      setSubopen("");
    } else {
      setSubopen(title);
    }
  };

  const toggleSubsidebar = (subitem) => {
    if (subitem === subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };

  const currentPath = Location.pathname;

  return (
    <div>
      <div className="sidebar" id="sidebar">
        <Scrollbars>
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul>
                {sidebarData?.map((mainLabel, index) => (
                  <li className="submenu-open" key={index}>
                    <h6 className="submenu-hdr">{mainLabel?.label}</h6>
                    <ul>
                      {mainLabel?.submenuItems?.map((title, i) => {
                        let link_array = [];
                        title?.submenuItems?.map((link) => {
                          link_array?.push(link?.link);
                          if (link?.submenu) {
                            link?.submenuItems?.map((item) => {
                              link_array?.push(item?.link);
                              return item;
                            });
                          }
                          return link;
                        });
                        title.links = link_array;
                        return (
                          <li className="submenu" key={i}>
                            <Link
                              to={title?.link}
                              onClick={() => toggleSidebar(title?.label)}
                              className={`${
                                subOpen === title?.label ? "subdrop" : ""
                              } ${
                                title?.links?.includes(currentPath) ? "active" : ""
                              }`}
                            >
                              {title?.icon}
                              <span>{title?.label}</span>
                              <span className={title?.submenu ? "menu-arrow" : ""}/>
                            </Link>
                            <ul
                              style={{
                                display: subOpen === title?.label ? "block" : "none",
                              }}
                            >
                              {title?.submenuItems?.map((item, titleIndex) => (
                                <li className="submenu submenu-two" key={titleIndex}>
                                  <Link
                                    to={item?.link}
                                    className={`${
                                      item?.submenuItems
                                        ?.map((link) => link?.link)
                                        .includes(currentPath) || item?.link === currentPath
                                        ? "active"
                                        : ""
                                    }`}
                                    onClick={() => {
                                      toggleSubsidebar(item?.label);
                                    }}
                                  >
                                    {item?.label}
                                  </Link>
                                  <ul
                                    style={{
                                      display: subsidebar === item?.label ? "block" : "none",
                                    }}
                                  >
                                    {item?.submenuItems?.map((items, titleIndex) => (
                                      <li key={titleIndex}>
                                        <Link
                                          to={items?.link}
                                          className={`${
                                            subsidebar === items?.label
                                              ? "submenu-two subdrop"
                                              : "submenu-two"
                                          } ${
                                            items?.submenuItems
                                              ?.map((link) => link.link)
                                              .includes(currentPath) ||
                                            items?.link === currentPath
                                              ? "active"
                                              : ""
                                          }`}
                                        >
                                          {items?.label}
                                        </Link>
                                      </li>
                                    ))}
                                  </ul>
                                </li>
                              ))}
                            </ul>
                          </li>
                        );
                      })}
                    </ul>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
      <HorizontalSidebar />
      <CollapsedSidebar />
    </div>
  );
};

export default Sidebar;
